import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Support-listing--------------------------
export const supportListApi = async (data) => {
  const endPoint =
    `ticket/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

// -------------------------Change Support Status------------
export const changeSupportStatusApi = async (data) => {
  const endPoint = `ticket/change_status`;
  return await axios.put(endPoint, data, setJwtToken());
};

// ---------------------upload-attachment----------------------------------
export const uploadAttachmentApi = async (data) => {
  const endPoint = `ticket/upload`
  return await axios.post(endPoint, data, setMultiPartHeader());
};